import React, { useState, useEffect } from 'react';
import { basePort, headers, queryParameters, renderRedirect } from "../../module_auth/AuthService"
import { PaginationCustom } from "../../component/common/PaginationCustom"
import { useNavigate, useLocation } from "react-router-dom"
import { TalentTableRow } from './TalentTableRow';
import { GridTalent } from './GridTalent';
import { isValidSearchPage, sendGoogleAnalytics } from '../common/BaseUtil';
import { Helmet } from 'react-helmet';
import '../../App.css'

export function TalentList() {
    const location = useLocation();
    const navigate = useNavigate();

    const [objectList, setObjectList] = useState([]);
    const [gridObjectList, setGridObjectList] = useState([]);
    const [cityList, setCityList] = useState([]);

    // pagination state
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const [redirect, setRedirect] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")

    const [searchInput, setSearchInput] = useState("");
    const [showSearchInputBadge, setShowSearchInputBadge] = useState(false);

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)
        getCityList();

        let currentPage = !isValidSearchPage(page)
            ? (localStorage.getItem("talentPage") || "1")
            : (page === "0" ? "1" : page);

        setCurrentPage(Number(currentPage));

        navigate("/talent_list?page=" + currentPage);
        localStorage.setItem("talentPage", currentPage);

        // API 경로 수정 (한인 전문가)
        let url = `${basePort}/get/search/talent/${currentPage}`;
        let premiumUrl = `${basePort}/get/premium/search/talent`;

        if (next != null) url = `${basePort}/get/search/talent/next/${currentPage}`;
        else if (previous != null) url = `${basePort}/get/search/talent/previous/${currentPage}`;

        let searchInputCache = localStorage.getItem("searchInput") || "";
        const searchObject = { searchInput: searchInputCache };

        // 프리미엄 재능 (그리드형) 조회
        fetch(premiumUrl, { method: 'post', headers, body: JSON.stringify(searchObject) })
            .then(response => response.json())
            .then(response => makeGridArray(response))
            .catch(error => console.error(error));

        // 일반 재능 (리스트형) 조회
        fetch(url, { method: 'post', headers, body: JSON.stringify(searchObject) })
            .then(response => response.json())
            .then(response => {
                setObjectList(response.cardList);
                setPageList(response.displayPages);
                setLastPage(response.lastPage);
                setActivePageIndex((currentPage - 1) % 2);

                if (searchInputCache !== "") {
                    setSearchInput(searchInputCache);
                    setShowSearchInputBadge(true);
                }
            }).catch(error => console.error(error));
    }, [page]);

    // 3열 그리드 배열 생성 로직
    function makeGridArray(list) {
        let grids = [];
        for (let i = 0; i < list.length; i += 3) {
            grids.push(list.slice(i, i + 3));
        }
        setGridObjectList(grids);
    }

    function getCityList() {
        fetch(`${basePort}/get/config`, { method: 'GET', headers })
            .then(response => response.json())
            .then(response => setCityList(response.cityEntityList))
            .catch(error => console.error(error));
    }

    // 입력 핸들러 및 검색 로직 (기존과 동일하되 경로만 talent로 유지)
    // ... (clickSearchSubmit, handleInputSearch, removeSearchInput 로직 생략)

    return (
        <div>
            {renderRedirect(redirect, '/talent_reg_select')}
            <Helmet>
                {/* 기본 Meta */}
                <title>지워커 | 독일 한인 지도·전문가·생활정보 플랫폼</title>
                <meta name="description" content="독일 거주 한인을 위한 필수 플랫폼! 한인지도, 분야별 한인전문가 프로필, 독일 생활·정착 블로그 정보를 한눈에 확인하세요." />
                <meta name="keywords" content="독일 한인 지도, 독일 한인 전문가, 독일 한인업소, 독일 생활 정보, 독일 한인 블로그, 지워커, gworker" />
                <meta name="robots" content="index,follow" />
                <link rel="canonical" href={`https://www.g-worker.co.kr/talent_list?page=${currentPage}`} />

                {/* Open Graph (SNS 공유용) */}
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="지워커 (G-Worker)" />
                <meta property="og:title" content="지워커 | 독일 한인 지도·전문가·생활정보 플랫폼" />
                <meta property="og:description" content="독일 거주 한인을 위한 필수 플랫폼! 한인지도, 분야별 한인전문가 프로필, 독일 생활·정착 블로그 정보를 한눈에 확인하세요." />
                <meta property="og:image" content="https://www.g-worker.co.kr/gworker_logo.jpg" />
                <meta property="og:url" content={`https://www.g-worker.co.kr/talent_list?page=${currentPage}`} />

                {/* 페이지네이션 (Pagination) */}
                {currentPage > 1 && <link rel="prev" href={`https://www.g-worker.co.kr/talent_list?page=${currentPage - 1}`} />}
                {currentPage < lastPage && <link rel="next" href={`https://www.g-worker.co.kr/talent_list?page=${currentPage + 1}`} />}
            </Helmet>
            <main className="page landing-page">
                <section className="container responsive-container-width" style={{ paddingTop: '100px', paddingBottom: '50px' }}>
                    {/* <div className="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row" style={{display: 'flex'}}>
                            <div class="col-md-6 d-md-flex justify-content-xl-center align-items-xl-center justify-content-xxl-center">
                                <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px', marginTop: '15px'}}>한인 전문가</p>
                            </div>
                            <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button"  onClick={() => setRedirect(true)} style={{borderRadius:'5px'}}>등록</button></div>
                        </div>
                    </div> */}

                    {/* 프리미엄 섹션 (그리드) */}
                    <div className="container">
                        <ol className="breadcrumb"><li className="breadcrumb-item"><span>프리미엄</span></li></ol>
                        {gridObjectList.map((row, idx) => (
                            <div className="row" key={idx}>
                                <GridTalent object={row} cityList={cityList} />
                            </div>
                        ))}
                    </div>

                    {/* 일반 섹션 (테이블) */}
                    <div className="container" style={{ marginTop: '50px' }}>
                        <ol className="breadcrumb"><li className="breadcrumb-item"><span>일반</span></li></ol>
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr className="responsive-table-row">
                                        <th style={{ width: '55%' }}>제목</th>
                                        <th style={{ width: '15%' }}>카테고리</th>
                                        <th style={{ width: '15%' }}>서비스지역</th>
                                        <th style={{ width: '15%' }}>가격정보</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {objectList.map((obj, idx) => (
                                        <TalentTableRow object={obj} key={idx} cityList={cityList} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <PaginationCustom
                        lastPage={lastPage} page={page} pageList={pageList}
                        activePageIndex={activePageIndex} url={'talent_list'}
                    />
                </section>
            </main>
        </div>
    );
}